import { OverviewEngineFactories } from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/client-extensions";
import { DefaultComponentMap } from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/view/configuration/component-map";

import { ActivityIdContext } from "../../component/ActivityContext";
import { CustomOverviewHeading } from "../../component/auxiliaryOverviewEngine/customHeading";

const nonInteractiveRowStyler = () => ({ interactive: false });
const customComponentMap = { ...DefaultComponentMap, Heading: CustomOverviewHeading };

export function LinksOverviewEngine(props: OverviewEngineFactories.ViewComponentProps) {
	const { activityId } = props;
	return (
		<ActivityIdContext.Provider value={activityId}>
			<OverviewEngineFactories.ViewComponent
				componentMap={customComponentMap}
				rowStyling={nonInteractiveRowStyler}
				{...props}
			/>
		</ActivityIdContext.Provider>
	);
}
